import "react-loading-skeleton/dist/skeleton.css";

import { isAdult } from "@/utils/profileUtilsTyped";
import type { PatientProfile } from "@/core/types";
import { usePatientConsents } from "@/features/consent/api/queries/usePatientConsents";
import type { UUID } from "@/core/types";

import { MemberProfileACPSection } from "../MemberProfileACPSection/MemberProfileACPSection";
import MemberProfileConsentList from "../MemberProfileConsentList";
import MemberProfilePolicyList from "../MemberProfilePolicyList";

import { MemberProfileConsentsSectionSkeleton } from "./MemberProfileConsentsSectionSkeleton";

type MemberProfileConsentsSectionProps = {
  dob?: PatientProfile["dob"];
  insuranceCarrier: string;
  patientId: UUID;
};

export function MemberProfileConsentsSection({
  dob,
  insuranceCarrier,
  patientId,
}: MemberProfileConsentsSectionProps) {
  const { data: consents, isLoading } = usePatientConsents(patientId);
  const isPatientAdult = isAdult(dob);

  if (isLoading || !consents) return <MemberProfileConsentsSectionSkeleton />;

  return (
    <>
      {isPatientAdult && (
        <MemberProfileACPSection
          consents={consents}
          insuranceCarrier={insuranceCarrier}
          patientId={patientId}
        />
      )}
      <MemberProfilePolicyList consents={consents} patientId={patientId} />
      <MemberProfileConsentList consents={consents} patientId={patientId} />
    </>
  );
}
